import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './NavBar.css';
import { NavLink } from 'react-router-dom'; // Import NavLink instead of Link

function NavBar() {
  return (
    <Navbar expand="lg">
      <Container>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav>
            <NavLink exact to="/" className="nav-link" activeClassName="active">Home</NavLink>
            <NavLink to="/about" className="nav-link" activeClassName="active">About Us</NavLink>
            <NavLink to="/service" className="nav-link" activeClassName="active">Service</NavLink>
            <NavLink to="/privatetour" className="nav-link" activeClassName="active">Private Tour</NavLink>
            <NavLink to="/ourfleet" className="nav-link" activeClassName="active">Our Fleet</NavLink>
            <NavLink to="/faq" className="nav-link" activeClassName="active">FAQ</NavLink>
            <NavLink to="/contact" className="nav-link" activeClassName="active">Contact Us</NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
